import React from "react";
import PropTypes from "prop-types";
import CommonModal from "./CommonModal";

import {
  buttonName,
  commonText,
  monthlyKPIReportsData
} from "../../locales/en";
import "./modalstyle.scss";
const KpiRefreshDataModal = ({
  isOpen,
  toggle,
  kpiRequestData,
  kpiRefreshErrorData
}) => {
  const handleClose = () => {
    toggle(false);
  };

  const extractTimeParts = (errorMessage) => {
    if (!errorMessage) return { timePart1: "", timePart2: "" };

    const parts = errorMessage.split("/");
    return {
      timePart1: parts[1] || "",
      timePart2: parts[2] || ""
    };
  };

  return (
    <CommonModal
      isOpen={isOpen}
      toggle={handleClose}
      title={monthlyKPIReportsData?.downloadModal?.refreshKpiReport}
      modalClassName="modal-dialog"
      footerButtons={[
        {
          label: buttonName.close,
          className: "btn btn-secondary",
          onClick: handleClose
        }
      ]}
    >
      <div className="row">
        <div className="col-12">
          {kpiRefreshErrorData && kpiRefreshErrorData.length > 0 ? (
            <>
              <p>
                <strong>{monthlyKPIReportsData?.downloadModal?.text4}</strong>
              </p>
              <p>{monthlyKPIReportsData?.downloadModal?.text5}</p>
              {kpiRefreshErrorData.map((error, index) => {
                const { timePart1, timePart2 } = extractTimeParts(error);
                return (
                  <div key={index}>
                    <p>
                      {`${monthlyKPIReportsData?.downloadModal?.text6} `}
                      {timePart1}.
                    </p>
                    <p>
                      {`${monthlyKPIReportsData?.downloadModal?.text7} `}
                      {timePart2}.
                    </p>
                  </div>
                );
              })}
            </>
          ) : (
            <>
              <p>
                <strong>{monthlyKPIReportsData?.downloadModal?.text1}</strong>
              </p>
              <p>
                {`${monthlyKPIReportsData?.downloadModal?.text2} `}
                {kpiRequestData?.status?.executionTimeFormattedPrevious}.
              </p>
              <p>
                {`${monthlyKPIReportsData?.downloadModal?.text3} `}
                {kpiRequestData?.status?.processingStartedAgo}
                {` ${commonText?.ago}`}.
              </p>
            </>
          )}
        </div>
      </div>
    </CommonModal>
  );
};

KpiRefreshDataModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  kpiRequestData: PropTypes.object,
  kpiRefreshErrorData: PropTypes.array
};

export default KpiRefreshDataModal;
